export default __webpack_public_path__ + "static/media/logo.a0d16744.svg";